import { render, staticRenderFns } from "./API.vue?vue&type=template&id=61141146&scoped=true"
import script from "./API.vue?vue&type=script&lang=js"
export * from "./API.vue?vue&type=script&lang=js"
import style0 from "./API.vue?vue&type=style&index=0&id=61141146&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61141146",
  null
  
)

export default component.exports